/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TotalDischarges { 
    number_of_totaldischarges?: number;
    time_between_totaldischarges?: number;
    discharge_amount?: number;
}

